import { Trascodifica } from "./trascodifica";
import { DocumentoImmobile } from "./documento-immobile";

export class DatoCatastale {
	id: number;
  catasto: Trascodifica;
	idCatasto: number;
	foglio: string;
	particella: string;
	subalterno: string;
	zonaCensuaria: string;
	idCategoria: number;
	categoria: Trascodifica;
	classe: string;
	idConsistenza: number;
	consistenza: Trascodifica;
	rendita: string;
	servizioVisuraAcquistato: boolean;
	servizioPlanimetriaAcquistato: boolean;
	servizioAttoNotarileAcquistato: boolean;
	servizioCertificazioneAcquistato: boolean;

	documentoVisura: DocumentoImmobile;
	documentoCertificazione: DocumentoImmobile;
	documentoPlanimetria: DocumentoImmobile;
	documentoAttoNotarile: DocumentoImmobile;
	
	valoreConsistenza: string;
  
  constructor() {
    this.catasto = new Trascodifica();
  }
}


// WEBPACK FOOTER //
// /home/david/vscode-workspace/TOP-casa-nel-web/frontend/src/app/models/dato-catastale.ts